"use client";

import { TranscriptDialog } from "@12-week/components/TranscriptDialog";
import VideoPlayer from "@12-week/components/VideoPlayer";
import { Video } from "@12-week/lib/types";
import { Button } from "@packages/components/ui/Button";
import Card from "@packages/components/ui/Card";
import React from "react";

export default function VideoPlayerCard({
  video,
  currentTime,
  as = "div",
  variant,
  streamRef,
  anchorId = "video",
  hideTranscript,
}: {
  video: Video;
  currentTime?: number;
  hideTranscript?: boolean;
  as?: "div" | "section";
  variant?: "sub" | "visualEmbed"; // Use "sub" for subCard, "visualEmbed" for visual embed like a FAQ video or image
  streamRef?: React.MutableRefObject<
    import("@cloudflare/stream-react").StreamPlayerApi | undefined
  >;
  anchorId?: string; // ID for the video player section
}) {
  const [transcriptOpen, setTranscriptOpen] = React.useState(false);

  return (
    <div className="relative w-full overflow-visible" id={anchorId}>
      <Card variant={variant} noPadding as={as}>
        <div role="region" aria-label="Video player" className="aspect-video">
          <h2 className="sr-only" id="video-title">
            {video.title ?? "Current Video"}
          </h2>
          <VideoPlayer
            video={video}
            currentTime={currentTime}
            streamRef={streamRef}
          />
        </div>
      </Card>
      {video.transcriptPath && !hideTranscript && (
        <>
          <div className="absolute right-2 -bottom-7">
            <Button
              type="button"
              variant="grayLink"
              size="default"
              onClick={() => setTranscriptOpen(true)}
              aria-label={`Show transcript of video: ${video.title}`}
              className="text-xs no-underline opacity-90 hover:underline hover:opacity-100 focus:underline focus:opacity-100"
            >
              <span aria-hidden="true">Video Transcript</span>
              <span className="sr-only">
                Transcript for video titled {video.title}
              </span>
            </Button>
          </div>
          <TranscriptDialog
            open={transcriptOpen}
            onOpenChange={setTranscriptOpen}
            transcriptPath={video.transcriptPath}
            videoTitle={video.title}
          />
        </>
      )}
    </div>
  );
}
